import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { GET } from "../../config/httpMain";
import SEOApiUrl from "../../config/apiURL/seoAPIURL";
import { COMPANYCODE, UPLOADIMAGES } from "../../constants/constant";
import { errorHandler } from "../../utility/errorHandler";
import { decodeParam } from "../../utility/utils";

const SEOContent = () => {
  const location = useLocation();
  const [data, setData] = useState<any>({});

  //#region Get  pageType and pageTypeId
  const getPageTypeAndId = () => {
    let path = location.pathname.replace(/^\/+/, "");
    let parts = path.split("/");
    let param1 = parts[1] ? decodeParam(parts[1]) : ""; //id
    let param2 = parts[2] ? decodeParam(parts[2]) : ""; //type


    let pageType = "home";
    let pageTypeId = param1;
    switch (parts[0]) {
      case "":
        pageType = "home";
        break;
      case "packages":
        if (parts?.length === 1)
          pageType = "packages";
        else if (param2 === "speciality")
          pageType = "packagesspeciality";
        else if (param2 === "packagetype")
          pageType = "packagestype";
        else if (param2 === "state")
          pageType = "packagesstate";
        else if (param2 === "country")
          pageType = "packagescountry";
        break;
      case "package":
        pageType = "package";
        break;
      default:
        break;
    }

    return { pageType, pageTypeId };
  }
  //#endregion

  const GetSEOContent = async () => {
    const { pageType, pageTypeId } = getPageTypeAndId();

    await GET(`${SEOApiUrl.GetSEOContent}?companyCode=${COMPANYCODE}&pageType=${pageType}&pageTypeId=${pageTypeId}`)
      .then((response: any) => {
        if (response?.data?.isSuccess) {
          let objdata = response?.data?.result;
          setData(objdata);
        }
        else
          errorHandler("response", response);
      }).catch((e: any) => {
        errorHandler("error", e);
      });
  }

  useEffect(() => {
    if (location?.pathname)
      GetSEOContent();
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>{data?.title || "Best Travel Agency in India | Luxury & Online Holiday Experts for Global Tours"}</title>

        <meta
          name="description"
          content={data?.metaDescription || "India’s Most Trusted Travel Experts"}
        />

        <meta
          name="keywords"
          content={data?.keywords}
        />


        {/* <link
          rel="canonical"
          href={data?.canonicalUrl}
        /> */}

        <meta property="og:title" content={data?.title} />
        <meta property="og:image" content={data?.imageFullName ? `${process.env.REACT_APP_FILEMANAGEMENTAPI_URL}/${UPLOADIMAGES}/${data?.imageType}/${data?.imageFullName}` : `${process.env.PUBLIC_URL}/assets/images/no-image.jpg`} />
      </Helmet>

      {/* <h1 className="seo-only">{data?.title}</h1>
      <div className="seo-only" dangerouslySetInnerHTML={{ __html: data?.content }} /> */}
    </>
  )
}
export default SEOContent;